export class ResetProjectDashboardsList {
  public static readonly type =
    '[Project/Dashboard/List] ResetProjectDashboardsList';
}
